import { nanoid } from 'nanoid';

export const headerData = [{
        id: 1,
        text: 'Длина дома, м',
        name: 'dlina'
    },
    {
        id: 2,
        text: 'Ширина дома, м',
        name: 'shirina'
    },
    {
        id: 3,
        text: 'Длина внутренних несущих стен, м',
        name: 'dlinaV'
    },
    {
        id: 4,
        text: 'Толщина наружной стены, мм',
        name: 'tolshinaN',
        dropdown: [200, 250, 300, 350, 375, 400, 500]
    },
    {
        id: 5,
        text: 'Толщина внутренних несущих стен, мм',
        name: 'tolshinaV',
        dropdown: [200, 250, 300, 350, 375, 400, 500]
    },
    {
        id: 6,
        text: 'Наличие перегородок',
        dropdown: ['нет', 'есть'],
        name: 'children',
        children: [{
                idChild: 1,
                name: 'dlinaOb',
                text: 'Общая длина перегородок, м'
            },
            {
                idChild: 2,
                name: 'tolshinaP',
                text: 'Толщина перегородок, мм',
                dropdown: [75, 100, 150, 200]
            },

        ]
    }
];


export function opening(id = nanoid()) {
    const allId = nanoid();
    return [{
            id: nanoid(),
            allId: allId,
            alias: 'floor-child-m',
            text: 'Высота проёма, м',
            name: `weight=?=${allId}`
        },
        {
            id: nanoid(),
            allId: allId,
            alias: 'floor-child-m',
            text: 'Ширина проёма, м',
            name: `height=?=${allId}`
        },
        {
            id: nanoid(),
            allId: allId,
            alias: 'floor-child-m',
            text: 'Количество проёмов данного типа',
            name: `col=?=${allId}`,
            defaultValue: 1
        }
    ]
}




export function getInitObj() {
    const id = nanoid();
    return {
        id: nanoid(),
        alias: 'floor',
        name: 'Полный',
        fields: [{
                id: nanoid(),
                alias: 'floor-child',
                text: 'Высота от пола до потолка, м',
                name: `weightfloor=?=${id}`
            },
            {
                id: nanoid(),
                alias: 'floor-child',
                type: 'number',
                text: 'Количество этажей данного типа',
                name: `countfloor=?=${id}`
            },
            // {
            //     id: nanoid(),
            //     alias: 'floor-child',
            //     // text: 'Тип перекрытий',
            //     // dropdown: ['Деревянные','Другие'],
            //     // children: [
            //     //     {
            //     //         text: 'Толщина блоков в уровне перекрытия, мм',
            //     //         id: Symbol('id'),
            //     //         dropdown: [75, 100, 150, 200, 250, 300, 350, 375, 400, 500]
            //     //     }
            //     // ]
            // }
        ],
        outdoor: {
            id: nanoid(),
            text: 'Проёмы в наружных стенах',
            count: 0,
            defaultFields: []
        },
        internal: {
            id: nanoid(),
            text: 'Проёмы во внутренних стенах',
            count: 0,
            defaultFields: []
        }
    }

}

export function storeyData() {
    const id = nanoid();
    return [{
        id: nanoid(),
        alias: 'floor',
        name: 'Полный',
        fields: [{
                id: nanoid(),
                alias: 'floor-child',
                text: 'Высота от пола до потолка, м',
                name: `weightfloor=?=${id}`
            },
            {
                id: nanoid(),
                alias: 'floor-child',
                text: 'Количество этажей данного типа',
                type: 'number',
                name: `countfloor=?=${id}`
            },
            // {
            //     id: nanoid(),
            //     alias: 'floor-child',
            //     // text: 'Тип перекрытий',
            //     // dropdown: ['Деревянные','Другие'],
            //     // children: [
            //     //     {
            //     //         text: 'Толщина блоков в уровне перекрытия, мм',
            //     //         id: Symbol('id'),
            //     //         dropdown: [75, 100, 150, 200, 250, 300, 350, 375, 400, 500]
            //     //     }
            //     // ]
            // }
        ],
        outdoor: {
            id: nanoid(),
            text: 'Проёмы в наружных стенах',
            count: 0,
            defaultFields: []
        },
        internal: {
            id: nanoid(),
            text: 'Проёмы во внутренних стенах',
            count: 0,
            defaultFields: []
        }
    }];
}


export function defaultMansard() {
    const id = nanoid();
    return {
        id: nanoid(),
        alias: 'floor',
        name: 'Мансардный',
        next: true,
        fields: [{
                id: nanoid(),
                text: 'Высота стен, м',
                name: `heigWall=?=${id}`
            },
            {
                id: nanoid(),
                text: 'Длина фронтона, м',
                name: `widthWallF=?=${id}`
            },
            {
                id: nanoid(),
                text: 'Высота фронтона, м',
                name: `heigWallF=?=${id}`
            },
        ],
        outdoor: {
            id: nanoid(),
            text: 'Проёмы в наружных стенах',
            count: 0,
            defaultFields: []
        },
        internal: {
            id: nanoid(),
            text: 'Проёмы во внутренних стенах',
            count: 0,
            defaultFields: []
        }
    }
}